import React from 'react';
import { Prompt } from 'react-router-dom';

import http from 'api/http';
import { oilAPI } from 'api/requests';

import Select from 'Components/Select';
import ApplicationActions from 'Components/ApplicationActions';
import { Input } from 'Components/Input';
import FilePicker from 'Components/FilePicker';
import NotificationManager from 'dom-managers/notification';
import Button, { buttonColor, buttonType } from 'Components/Button';
import Modal from 'Components/Modal';

export default class FormulaCreate extends React.Component {
  constructor(props) {
    super(props);

    this.formulaTypes = [
      {
        name: 'Base Formulation',
        requiredFields: ['formulatorNumber', 'manufacturerAddress', 'testReports', 'chosenEngineType'],
        isReadAcrossFormula: false
      },
      {
        name: 'Read Across Formulation',
        requiredFields: ['formulatorNumber', 'manufacturerAddress', 'testReports', 'chosenEngineType', 'chosenBaseFormula'],
        isReadAcrossFormula: true
      }
    ];

    this.state = {
      chosenFormulaType: {},
      inputErrors: {},
      formulatorNumber: '',
      chosenEngineType: '',
      manufacturerAddress: '',
      testReports: [],
      chosenBaseFormula: '',
      description: '',
      isModalOpen: false,
      requestInProcess: false,
    };

    this.someDataWasInputted = false;
    this.modalBody = '';
  }

  handleSelect = fieldName => input => {
    const {inputErrors} = this.state;
    let newInputErrors = inputErrors;
    const selectedItem = input;

    delete newInputErrors[fieldName];
    this.someDataWasInputted = true;
    this.setState({[fieldName]: selectedItem, inputErrors: newInputErrors});
  };

  handleFormulaTypeSelect = input => {
    this.someDataWasInputted = true;
    this.setState({chosenFormulaType: input, inputErrors: {}});
  };

  handleEngineTypeSelect = input => {
    const {inputErrors} = this.state;
    delete inputErrors.chosenEngineType;
    delete inputErrors.chosenBaseFormula;
    this.someDataWasInputted = true;
    this.setState({chosenEngineType: input, chosenBaseFormula: '', inputErrors});
  };

  handleInputChange = field => (value, error) => {
    const {inputErrors} = this.state;
    if (!error  || error.ops) {
      delete inputErrors[field];
      this.someDataWasInputted = true;
      this.setState({[field]: value, inputErrors});
    }
  };

  handleFileSelect = files => {
    let newInputErrors = this.state.inputErrors;
    delete newInputErrors.testReports;
    this.someDataWasInputted = true;
    this.setState(prevState => ({
      testReports: [...prevState.testReports, ...files],
      inputErrors: newInputErrors,
    }));
  };

  handleRemoveFile = index => () => {
    this.setState(prevState => {
      prevState.testReports.splice(index, 1);
      return {testReports: prevState.testReports};
    });
  };


  validateForm = () => {
    const {inputErrors, chosenFormulaType} = this.state;
    let newInputErrors = inputErrors;

    const isEmptyArray = object => {
      return object.length !== undefined && typeof object === 'object' && !object.length;
    };

    const isEmptyString = object => {
      return !object.length && typeof object === 'string' && !object.length;
    };

    const isEmptyObject = object => {
      return object.length === undefined && typeof object === 'object' && !Object.keys(object).length;
    };

    chosenFormulaType.requiredFields.forEach(fieldName => {
      if (isEmptyString(this.state[fieldName]) || isEmptyArray(this.state[fieldName]) || isEmptyObject(this.state[fieldName])) newInputErrors[fieldName] = true;
    });

    return new Promise((resolve, reject) => {this.setState({inputErrors: newInputErrors}, () => {if (Object.keys(this.state.inputErrors).length) reject(); else resolve();});});
  };

  submitFormula = () => {
    const {chosenFormulaType, chosenEngineType, formulatorNumber, manufacturerAddress, testReports, chosenBaseFormula, description} = this.state;
    const {user, updateSingleListEntry} = this.props;

    this.validateForm()
      .then(() => {
        const headers = {
          'Content-Type': 'multipart/form-data'
        };

        let dataPayload = {
          formulatorNumber,
          engineType: chosenEngineType,
          manufacturerAddress: manufacturerAddress.value,
          isReadAcrossFormula: chosenFormulaType.isReadAcrossFormula,
          description
        };

        if (dataPayload.isReadAcrossFormula) dataPayload.baseFormulaId = chosenBaseFormula;

        const data = new FormData();
        data.append('requestJson', JSON.stringify(dataPayload));
        testReports.forEach(file => data.append('reports', file));

        this.modalBody = 'Are you sure you want to submit this application?';
        this.modalConfirmAction = () => {
          this.setState({requestInProcess: true}, () => {
            http.post(oilAPI.submitFormula, data, {headers})
              .then(({data}) => {
                NotificationManager.success(1, 'Your application was submitted successfully');
                updateSingleListEntry()(data);
                this.someDataWasInputted = false;
                user.goToList(false, false);
              })
              .finally(() => {
                this.setState({requestInProcess: false});
                this._closeModal();
              });
          });
        };

        this._openModal();
      });
  };

  handleBackButtonClick = () => {
    const {user} = this.props;
    user.goToList();
  };

  _openModal = () => {
    this.setState({isModalOpen: true});
  };

  _closeModal = () => {
    this.setState({isModalOpen: false, requestInProcess: false});
  };

  blockUnconfirmedTransition = location => {
    const {user} = this.props;

    if (this.someDataWasInputted) {
      this.modalBody = 'You have unsaved data. Are you sure you want to exit application without saving?';
      this.modalConfirmAction = () => {
        this.someDataWasInputted = false;
        this._closeModal();
        user.goTo(location);
      };
      this._openModal();
      return false;
    }
    return true;
  };

  render() {
    const {
      chosenFormulaType, inputErrors, chosenEngineType, formulatorNumber, manufacturerAddress, testReports,
      chosenBaseFormula, description, isModalOpen, requestInProcess
    } = this.state;
    const {engineTypes, formulasList, listRequestInProgress, manufacturerAddresses} = this.props;

    return (
      <React.Fragment>
        <section className='scene__scene-wrapper'>
          <section className='scene__content-wrapper'>
            <section className='scene__scene-header detailsScene__scene-header'>
              <div className='go-back-to-list-header-button' onClick={this.handleBackButtonClick}>
                Back
              </div>
              <header>New Formulation Application</header>
            </section>
            <section className='scene_section'>
              <header>General Info</header>
              <Select
                selectionList={this.formulaTypes}
                defaultItem={chosenFormulaType}
                type='primary'
                inputClassName=''
                dropDownClassName=''
                label='Formulation Type *'
                placeholder='Please select formulation type'
                itemNameIndicator='name'
                error={inputErrors.chosenFormulaType}
                handleSelect={this.handleFormulaTypeSelect}
              />
            </section>
            <section className='scene_section'>
              <header>General Info</header>
              <Input
                mainWrapperClassName='input__main-wrapper_primary _width_pc_100'
                inputClassName='input__input-field_primary'
                maxLength={250}
                label={'Formulation Number *'}
                value={formulatorNumber}
                error={inputErrors.formulatorNumber}
                onChange={this.handleInputChange('formulatorNumber')}
              />
              <Select
                selectionList={engineTypes}
                defaultItem={chosenEngineType}
                type='primary'
                mainWrapperClassName='_margin_right_30'
                label='Engine Oil Type *'
                placeholder='Please select engine type'
                error={inputErrors.chosenEngineType}
                handleSelect={this.handleEngineTypeSelect}
              />
              {chosenFormulaType.isReadAcrossFormula && (
                /*
                { <Select
                  selectionList={formulasList.filter(
                    formula => formula.applicationStatus === 'APPROVED' && (formula.engineType === chosenEngineType || (chosenEngineType === 'FC-W(CAT)' && formula.engineType === 'FC-W'  ))
                  )}
                  defaultItem={chosenBaseFormula}
                  isSlave
                  type='primary'
                  label='Read Across Source *'
                  placeholder='Please select base Oil number'
                  disabled={!chosenEngineType}
                  isLoading={listRequestInProgress}
                  itemNameIndicator='baseOilNumber'
                  error={inputErrors.chosenBaseFormula}
                  handleSelect={this.handleSelect('chosenBaseFormula')}
                /> */
                <Input
                  mainWrapperClassName='input__main-wrapper_primary'
                  inputClassName='input__input-field_primary'
                  label='Read Across Source *'
                  maxLength={30}
                  placeholder={'Please provide base Oil number'}
                  value={chosenBaseFormula}
                  onChange={this.handleInputChange('chosenBaseFormula')}
                />
              )}
              <Input
                mainWrapperClassName='input__main-wrapper_primary _width_pc_100'
                inputClassName='input__input-field_primary'
                label='Description'
                maxLength={250}
                placeholder={'Provide some description if necessary'}
                value={description}
                onChange={this.handleInputChange('description')}
              />
            </section>
            <section className='scene_section'>
              <header>Address</header>
              <Select
                selectionList={manufacturerAddresses}
                type='primary'
                mainWrapperClassName='select__main-wrapper_primary _width_pc_100'
                defaultItem={manufacturerAddress}
                label='Select Address *'
                itemNameIndicator='name'
                error={inputErrors.manufacturerAddress}
                handleSelect={this.handleSelect('manufacturerAddress')}
              />
            </section>
            <section className='scene_section'>
              <FilePicker
                files={testReports}
                handleFileSelect={this.handleFileSelect}
                handleRemoveFile={this.handleRemoveFile}
                editableStateSectionHeader='Upload Test Report and Supporting Documentation'
                sectionHeaderClassName='_margin_top_0 _font_size_14'
                error={inputErrors.testReports ? 'Please upload at least one report' : ''}
              />
            </section>
            <ApplicationActions
              saveButtonLabel='Submit'
              saveButtonAction={this.submitFormula}
              cancelButtonLabel='Cancel'
              cancelButtonAction={this.handleBackButtonClick}
            />
          </section>
        </section>
        <Modal isOpen={isModalOpen}>
          <header className='ect-modal-header'>Confirmation</header>
          <div className='ect-modal-body'>{this.modalBody}</div>
          <footer className='ect-modal-footer'>
            <Button
              label='No'
              type={buttonType.secondary}
              color={buttonColor.gray}
              buttonClassName='_height_40 _width_160'
              onClick={this._closeModal}
            />
            <Button
              label='Yes'
              disabledWithSpinner={requestInProcess}
              buttonClassName='_height_40 _width_160'
              onClick={this.modalConfirmAction}
            />
          </footer>
        </Modal>
        <Prompt message={this.blockUnconfirmedTransition} />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/Application/Create/index.jsx